var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMac(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.706 15.165c.848-1.114 1.428-2.628 1.267-4.165-1.227.057-2.761.891-3.645 1.98-.781.96-1.48 2.532-1.3 4.01 1.379.109 2.794-.73 3.678-1.825m3.67 9.111c-.032-3.163 2.796-4.702 2.926-4.774-1.602-2.162-4.084-2.458-4.957-2.481-2.085-.203-4.107 1.155-5.169 1.155-1.083 0-2.719-1.136-4.481-1.102-2.269.032-4.39 1.248-5.554 3.137-2.402 3.85-.611 9.509 1.69 12.621 1.151 1.525 2.496 3.226 4.257 3.166 1.722-.064 2.366-1.015 4.444-1.015 2.06 0 2.664 1.015 4.46.977 1.848-.026 3.012-1.531 4.122-3.069 1.33-1.746 1.865-3.468 1.886-3.556-.042-.014-3.589-1.268-3.625-5.059"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMac);
export default __webpack_public_path__ + "static/media/Mac.21949cec.svg";
export { ForwardRef as ReactComponent };